import { Box } from "@mui/system";
import { useRef } from "react";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";
import { useEntityInputFormInfo } from "@/common/hooks/entity/useEntityInputFormInfo";

import AppModalContent from "../../Modals/AppModalContent";
import {
  BaseEntityCreateUpdateModal,
  BaseEntityCreateUpdateModalInheritableProps,
} from "../components/BaseEntityCreateUpdateModal";
import RepairWorkCreateUpdate, {
  RepairWorkCreateUpdateHandle,
  RepairWorkCreateUpdateProps,
} from "./RepairWorkCreateUpdate";

interface Props extends BaseEntityCreateUpdateModalInheritableProps {
  createUpdateProps: RepairWorkCreateUpdateProps;
}

export default function RepairWorkCreateUpdateModal({ createUpdateProps, ...modalProps }: Props) {
  const formInfo = useEntityInputFormInfo({ entityId: createUpdateProps.repairWorkId });
  const formWrapperRef = useRef<RepairWorkCreateUpdateHandle | null>(null);

  return (
    <BaseEntityCreateUpdateModal
      fullWidth
      maxWidth='lg'
      {...modalProps}
      formWrapperRef={formWrapperRef}
    >
      {(params) => (
        <>
          <AppModalTitle onClose={params.close}>
            {formInfo.isCreate ? "Create new" : "Edit"} repair work
          </AppModalTitle>
          <AppModalContent>
            <Box sx={{ py: 1 }}>
              <RepairWorkCreateUpdate ref={formWrapperRef} {...createUpdateProps} />
            </Box>
          </AppModalContent>
        </>
      )}
    </BaseEntityCreateUpdateModal>
  );
}
